var _style, _circle, _path, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFollowiconIns = function SvgFollowiconIns(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Followicon-ins_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Followicon-ins_svg__st0{fill:#fff}.Followicon-ins_svg__st0,.Followicon-ins_svg__st1{display:none}.Followicon-ins_svg__st2{display:inline}.Followicon-ins_svg__st3{fill:#333}.Followicon-ins_svg__st4{fill:#fff}.Followicon-ins_svg__st5{fill:none;stroke:#fff;stroke-miterlimit:10}.Followicon-ins_svg__st7,.Followicon-ins_svg__st8{display:inline;fill:#fff}.Followicon-ins_svg__st8{fill:#333}.Followicon-ins_svg__st9{fill:none;stroke:#333;stroke-width:88;stroke-linecap:round;stroke-miterlimit:10}.Followicon-ins_svg__st10,.Followicon-ins_svg__st11,.Followicon-ins_svg__st9{display:inline}.Followicon-ins_svg__st10{fill:#446cb3}.Followicon-ins_svg__st11{fill-rule:evenodd;clip-rule:evenodd}.Followicon-ins_svg__st11,.Followicon-ins_svg__st12{fill:#446cb3}.Followicon-ins_svg__st13{display:inline;fill:#555}.Followicon-ins_svg__st14{fill-rule:evenodd;clip-rule:evenodd;fill:#333}.Followicon-ins_svg__st15{display:none;fill:#333}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 508.4,
    cy: 521.5,
    r: 106.3,
    className: "Followicon-ins_svg__st4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 65C265.1 65 65 265.1 65 512s200.1 447 447 447 447-200.1 447-447S758.9 65 512 65zm234.2 551.5c0 76.4-62 138.4-138.4 138.4H403.6c-76.4 0-138.4-62-138.4-138.4V417.8c0-76.4 62-138.4 138.4-138.4h204.2c76.4 0 138.4 62 138.4 138.4v198.7z",
    className: "Followicon-ins_svg__st4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 648.4,
    cy: 379.3,
    r: 28.7,
    className: "Followicon-ins_svg__st4",
    transform: "rotate(-22.5 648.384 379.32)"
  })));
};
export default SvgFollowiconIns;